export default class Company {
    constructor() {
        this.id;
        this.representativeId;
        this.representativeName;
        this.subscriptionId;
        this.subscriptionName;
        this.subscriptionAmount;
        this.subscriptionDependantsCount;
        this.representativeProductId;
        this.representativeProductName;
        this.representativeProductCode;
        this.titles;
        this.initials;
        this.surname;
        this.gender;
        this.identityNumber;
        this.cellNumber;
        this.workNumber;
        this.email;
        this.address;
        this.city;
        this.postalCode;
        this.dependant1Initials;
        this.dependant1Surname;
        this.dependant1Gender;
        this.dependant1IdentityNumber;
        this.dependant2Initials;
        this.dependant2Surname;
        this.dependant2Gender;
        this.dependant2IdentityNumber;
        this.dependant3Initials;
        this.dependant3Surname;
        this.dependant3Gender;
        this.dependant3IdentityNumber;
        this.dependant4Initials;
        this.dependant4Surname;
        this.dependant4Gender;
        this.dependant4IdentityNumber;
        this.dependant5Initials;
        this.dependant5Surname;
        this.dependant5Gender;
        this.dependant5IdentityNumber;
        this.createdAt;
        this.accisureFormStatus;
        this.bankAccountNumber;
        this.bankName;
        this.bankBranchCode;
        this.accisureDebitOrderDate;
        this.commencementDate;
        this.signatureImageBase64;
        this.allergies;
        this.postalAddress;
        this.agreedToTermsAndConditions;
        this.agreedToMedicalConsent;
        this.agreedToDebitOrder;
        this.subscribeFormFileId;
        this.identityFileId;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.representativeId = setEntity.representativeId;
        this.representativeName = setEntity.representativeName;
        this.subscriptionId = setEntity.subscriptionId;
        this.subscriptionName = setEntity.subscriptionName;
        this.subscriptionAmount = setEntity.subscriptionAmount;
        this.subscriptionDependantsCount = setEntity.subscriptionDependantsCount;
        this.representativeProductId = setEntity.representativeProductId;
        this.representativeProductName = setEntity.representativeProductName;
        this.representativeProductCode = setEntity.representativeProductCode;
        this.titles = setEntity.titles;
        this.initials = setEntity.initials;
        this.surname = setEntity.surname;
        this.gender = setEntity.gender;
        this.identityNumber = setEntity.identityNumber;
        this.cellNumber = setEntity.cellNumber;
        this.workNumber = setEntity.workNumber;
        this.email = setEntity.email;
        this.address = setEntity.address;
        this.city = setEntity.city;
        this.postalCode = setEntity.postalCode;
        this.dependant1Initials = setEntity.dependant1Initials;
        this.dependant1Surname = setEntity.dependant1Surname;
        this.dependant1Gender = setEntity.dependant1Gender;
        this.dependant1IdentityNumber = setEntity.dependant1IdentityNumber;
        this.dependant2Initials = setEntity.dependant2Initials;
        this.dependant2Surname = setEntity.dependant2Surname;
        this.dependant2Gender = setEntity.dependant2Gender;
        this.dependant2IdentityNumber = setEntity.dependant2IdentityNumber;
        this.dependant3Initials = setEntity.dependant3Initials;
        this.dependant3Surname = setEntity.dependant3Surname;
        this.dependant3Gender = setEntity.dependant3Gender;
        this.dependant3IdentityNumber = setEntity.dependant3IdentityNumber;
        this.dependant4Initials = setEntity.dependant4Initials;
        this.dependant4Surname = setEntity.dependant4Surname;
        this.dependant4Gender = setEntity.dependant4Gender;
        this.dependant4IdentityNumber = setEntity.dependant4IdentityNumber;
        this.dependant5Initials = setEntity.dependant5Initials;
        this.dependant5Surname = setEntity.dependant5Surname;
        this.dependant5Gender = setEntity.dependant5Gender;
        this.dependant5IdentityNumber = setEntity.dependant5IdentityNumber;
        this.createdAt = setEntity.createdAt;
        this.accisureFormStatus = setEntity.accisureFormStatus;
        this.bankAccountNumber = setEntity.bankAccountNumber;
        this.bankName = setEntity.bankName;
        this.bankBranchCode = setEntity.bankBranchCode;
        this.accisureDebitOrderDate = setEntity.accisureDebitOrderDate;
        this.commencementDate = setEntity.commencementDate;
        this.signatureImageBase64 = setEntity.signatureImageBase64;
        this.allergies = setEntity.allergies;
        this.postalAddress = setEntity.postalAddress;
        this.agreedToTermsAndConditions = setEntity.agreedToTermsAndConditions;
        this.agreedToMedicalConsent = setEntity.agreedToMedicalConsent;
        this.agreedToDebitOrder = setEntity.agreedToDebitOrder;
        this.subscribeFormFileId = setEntity.subscribeFormFileId;
        this.identityFileId = setEntity.identityFileId;
        this.cardNumber = setEntity.cardNumber;
        this.signedByUserId = setEntity.signedByUserId;
        return this;
    }
}
